import './biz-pagination.scss';

type PaginationProps = {
	pageIndex: number;
	pageSize: number;
	currentPageLength: number;
	totalItemCount: number;
	pageIndexChanged: (newPageIndex: number) => void;
};

const BizPagination = ({ pageIndex, pageSize, currentPageLength, totalItemCount, pageIndexChanged }: PaginationProps) => {
	const pageCount = Math.ceil(totalItemCount / pageSize);
	const getFirstPageItemNbr = () => {
		return pageIndex * pageSize + 1;
	};

	const getLastPageItemNbr = () => {
		return pageIndex * pageSize + currentPageLength;
	};

	const pageIndexChangedHandler = (newPageIndex: number) => {
		if (newPageIndex >= 0 && newPageIndex < pageCount) {
			pageIndexChanged(newPageIndex);
		}
	};

	const firstPageItemNbr = getFirstPageItemNbr();
	const lastPageItemNbr = getLastPageItemNbr();
	const pageList = Array.from({ length: pageCount ?? 0 }, (_, i) => i);

	const renderAllPagesNavigation = () => {
		return pageList.map((idx) => (
			<li key={idx} className={pageIndex === idx ? 'active' : ''}>
				<a onClick={() => pageIndexChangedHandler(idx)}>{idx + 1}</a>
			</li>
		));
	};

	const getPageNavigation = () => {
		return pageCount > 10 ? renderPageNavigation(pageIndex, pageCount, pageIndexChangedHandler) : renderAllPagesNavigation();
	};

	return (
		<div className='biz-pagination'>
			{currentPageLength === 0 && <p>No items found matching the current filter values</p>}
			{currentPageLength > 0 && (
				<p className='paging-text'>
					Showing items {firstPageItemNbr}-{lastPageItemNbr} out of {totalItemCount}
				</p>
			)}
			<ul className='pagination clean-list'>{getPageNavigation()}</ul>
		</div>
	);
};

export default BizPagination;

function renderPageNavigation(pageIndex: number, pageCount: number, pageIndexChangedHandler: (newPageIndex: number) => void) {
	return (
		<>
			<li>
				<a onClick={() => pageIndexChangedHandler(0)}>
					<i className='fas fa-angle-double-left' />
				</a>
			</li>
			<li>
				<a onClick={() => pageIndexChangedHandler(pageIndex - 1)}>
					<i className='fas fa-angle-left' />
				</a>
			</li>
			<li>
				<span className='page-info'>
					<input
						type='number'
						value={pageIndex + 1}
						onChange={(e) => pageIndexChangedHandler(e.target.valueAsNumber - 1)}
						min={1}
						max={pageCount}
					/>
					of {pageCount}
				</span>
			</li>
			<li>
				<a onClick={() => pageIndexChangedHandler(pageIndex + 1)}>
					<i className='fas fa-angle-right' />
				</a>
			</li>
			<li>
				<a onClick={() => pageIndexChangedHandler(pageCount - 1)}>
					<i className='fas fa-angle-double-right' />
				</a>
			</li>
		</>
	);
}
